import { memo } from "react";
import { NUTRI_COLORS, NUTRI_GRADES } from "../utils/scoreFormatter";

/**
 * Nutri-Score strip A–E with the product's grade raised in its solid colour
 * and the others tinted. The grade comes from the nutrition service
 * (declared on the pack or calculated); without one the strip is greyed out.
 */
function NutriScore({ grade, size = "small", showLabel = true, boxed = false }) {
  const known = NUTRI_GRADES.includes(grade);
  return (
    <span
      className={`ep-nutri ${size === "large" ? "is-large" : ""} ${known ? "" : "is-unknown"} ${boxed ? "ep-nutri-box" : ""}`}
      role="img"
      aria-label={known ? `Nutri-Score ${grade}` : "Nutri-Score not available"}
    >
      {showLabel && <span className="ep-nutri-label">Nutri-Score</span>}
      <span className="ep-nutri-grades" aria-hidden="true">
        {NUTRI_GRADES.map((g) => {
          const selected = g === grade;
          return (
            <span
              key={g}
              className={`ep-nutri-grade ${selected ? "is-selected" : ""}`}
              style={
                selected
                  ? { background: NUTRI_COLORS[g] }
                  : { background: `${NUTRI_COLORS[g]}26`, color: NUTRI_COLORS[g] }
              }
            >
              {g}
            </span>
          );
        })}
      </span>
    </span>
  );
}

export default memo(NutriScore);
